<template>
  <div class="mod-sale-price-list">
    <el-form class="toolbar" :inline="true" :model="dataForm" @keyup.enter.native="pageIndex = 1; getDataList()">
      <el-form-item label="价目表编码">
        <el-input v-model="dataForm.priceListCode" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="价目表名称">
        <el-input v-model="dataForm.priceListName" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="客户">
        <el-input v-model="dataForm.customerName" size="small" clearable style="width:150px" />
      </el-form-item>
      <el-form-item label="审核">
        <el-select v-model="dataForm.approveStatus" clearable size="small" style="width:120px">
          <el-option label="未审" value="0" />
          <el-option label="已审" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('sale:salePriceList:list')" type="primary" size="small" @click="pageIndex = 1; getDataList()">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button v-if="isAuth('sale:salePriceList:save')" type="primary" size="small" @click="addOrUpdateHandle()">新增</el-button>
      </el-form-item>
    </el-form>

    <el-table :data="dataList" border v-loading="dataListLoading" :header-cell-style="{ background: '#f5f7fa', color: '#606266', textAlign: 'center' }">
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="priceListCode" label="价目表编码" min-width="130" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('sale:salePriceList:info')" class="code-link" @click="addOrUpdateHandle(scope.row.priceListId, true)">{{ scope.row.priceListCode }}</a>
          <span v-else>{{ scope.row.priceListCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="priceListName" label="价目表名称" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="customerName" label="客户" min-width="120" header-align="center" align="left" show-overflow-tooltip>
        <template slot-scope="scope">{{ scope.row.customerName || '通用' }}</template>
      </el-table-column>
      <el-table-column prop="effectiveFrom" label="生效日期" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ (scope.row.effectiveFrom || '').slice(0, 10) }}</template>
      </el-table-column>
      <el-table-column prop="effectiveTo" label="失效日期" width="110" header-align="center" align="left">
        <template slot-scope="scope">{{ scope.row.effectiveTo ? (scope.row.effectiveTo || '').slice(0, 10) : '—' }}</template>
      </el-table-column>
      <el-table-column prop="priority" label="优先级" width="80" header-align="center" align="left" />
      <el-table-column prop="approveStatus" label="状态" width="90" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="statusTagType(scope.row)" size="small">{{ statusText(scope.row) }}</el-tag>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      class="list-pagination"
      background
      @size-change="val => { pageSize = val; pageIndex = 1; getDataList() }"
      @current-change="val => { pageIndex = val; getDataList() }"
      :current-page="pageIndex"
      :page-sizes="[20, 50, 100]"
      :page-size="pageSize"
      :total="totalPage"
      layout="total, sizes, prev, pager, next, jumper"
    />

    <sale-price-list-dialog v-if="addOrUpdateVisible" ref="addOrUpdate" :is-auth="isAuth" @refreshDataList="getDataList" />
  </div>
</template>

<script>
import SalePriceListDialog from './SalePriceListDialog.vue'
import { listSalePriceList } from '../../api/sale/salePriceList'
import { fetchPerms } from '../../api/auth'
import { workflowStatusText, workflowStatusTagType } from '../../utils/workflow'

export default {
  name: 'SalePriceList',
  components: { SalePriceListDialog },
  data() {
    return {
      dataForm: { priceListCode: '', priceListName: '', customerName: '', approveStatus: '' },
      dataList: [],
      pageIndex: 1,
      pageSize: 20,
      totalPage: 0,
      dataListLoading: false,
      addOrUpdateVisible: false,
      permCodes: []
    }
  },
  created() {
    this.loadPerms()
    this.getDataList()
  },
  activated() {
    this.getDataList()
  },
  methods: {
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) {
        return true
      }
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() {
      fetchPerms().then(res => {
        this.permCodes = res.data || []
      }).catch(() => {})
    },
    statusText(row) {
      return workflowStatusText(row.workflowStatus, row.approveStatus)
    },
    statusTagType(row) {
      return workflowStatusTagType(row.workflowStatus, row.approveStatus)
    },
    getDataList() {
      this.dataListLoading = true
      listSalePriceList({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        ...this.dataForm
      }).then(res => {
        this.dataListLoading = false
        const body = res.data || {}
        this.dataList = body.list || []
        this.totalPage = body.totalCount || 0
      }).catch(() => {
        this.dataListLoading = false
      })
    },
    addOrUpdateHandle(id, readonly) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.init(id, readonly)
      })
    },
    open(id, readonly) { this.addOrUpdateHandle(id, !!readonly) }
  }
}
</script>

<style scoped>
.list-pagination {
  margin-top: 10px;
  text-align: right;
}
.code-link {
  color: #2563eb;
  cursor: pointer;
}
.toolbar >>> .el-form-item {
  margin-bottom: 8px;
}
</style>
